import React from 'react';
import { ConfigContext } from '../../providers/ConfigContext';
import { LogoWrapper } from './styles';
import { getRouterBasename } from '../../util/getRouterBasename';

export const Logo = () => {
  const config = ConfigContext.useContainer();
  // For local development, proxy via staging to avoid needing the asset locally.
  // For all deployed environments (including dev-cognito), resolve from the current
  // domain's origin, so the correct deployment host is always used.
  const routerBasename = getRouterBasename();
  const basePath =
    config.env === 'local'
      ? 'https://staging.port-insider.com'
      : `${window.location.origin}${routerBasename}`;

  return <LogoWrapper src={`${basePath}/assets/img/logo.svg?v=2`} alt="Logo" />;
};
